{
  "frozen-columns-onboarding.spotlight.body": [
    {
      "type": 0,
      "value": "Sort, freeze and resize Work from a single control."
    }
  ],
  "frozen-columns-onboarding.spotlight.dismiss": [
    {
      "type": 0,
      "value": "OK"
    }
  ],
  "frozen-columns-onboarding.spotlight.heading": [
    {
      "type": 0,
      "value": "Manage Work"
    }
  ],
  "jira-nin-group-by-any-field-changeboarding.spotlight.body": [
    {
      "type": 0,
      "value": "Group work by fields including versions, labels, work types and more."
    }
  ],
  "jira-nin-group-by-any-field-changeboarding.spotlight.dismiss": [
    {
      "type": 0,
      "value": "OK"
    }
  ],
  "jira-nin-group-by-any-field-changeboarding.spotlight.heading": [
    {
      "type": 0,
      "value": "Group work to stay organized"
    }
  ],
  "timeline-10k-issues-flag.actions": [
    {
      "type": 0,
      "value": "Learn more about the 10k limit"
    }
  ],
  "timeline-10k-issues-flag.description": [
    {
      "type": 0,
      "value": "Parent rollup bars in timeline have been disabled to give you a smoother performance and experience."
    }
  ],
  "timeline-10k-issues-flag.title": [
    {
      "type": 0,
      "value": "This space has more than 10k work items."
    }
  ],
  "timeline-feedback-collector.spotlight.body": [
    {
      "type": 0,
      "value": "In doing this we are keen to hear feedback from users about the timeline, what else you may want, and importantly, what you don’t want."
    }
  ],
  "timeline-feedback-collector.spotlight.dismiss": [
    {
      "type": 0,
      "value": "Dismiss"
    }
  ],
  "timeline-feedback-collector.spotlight.give-feedback": [
    {
      "type": 0,
      "value": "Give feedback"
    }
  ],
  "timeline-feedback-collector.spotlight.heading": [
    {
      "type": 0,
      "value": "We’re updating Jira timelines"
    }
  ]
}